import React, { useEffect, useState } from 'react';
import { contactService } from '@/api/services/contactService';
import { ContactList } from '@/components/contacts/ContactList';
import { Card } from '@/components/ui/card';
import { ContactsHeader } from '@/components/contacts/ContactsHeader';
import { ContactListControls } from '@/components/contacts/ContactListControls';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { usePageHeader } from '@/contexts/PageHeaderContext';
import { UserCheck } from 'lucide-react';
const Visitors = () => {
  const {
    setHeaderData
  } = usePageHeader();
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const totalVisitors = visitors.length;
    const newVisitors = visitors.filter((visitor: any) => visitor.isNew).length;
    const returningVisitors = visitors.filter((visitor: any) => visitor.visitCount > 1).length;
    setHeaderData({
      title: 'Visitors',
      description: 'Track and manage website visitors and their activity',
      icon: UserCheck,
      stats: [{
        label: 'Total Visitors',
        value: totalVisitors,
        color: 'text-gray-900',
        dotColor: 'bg-blue-500'
      }, {
        label: 'New',
        value: newVisitors,
        color: 'text-green-600',
        dotColor: 'bg-green-500'
      }, {
        label: 'Returning',
        value: returningVisitors,
        color: 'text-purple-600',
        dotColor: 'bg-purple-500'
      }]
    });
  }, [visitors, setHeaderData]);
  useEffect(() => {
    setLoading(true);
    contactService.fetchVisitors().then(res => {
      setVisitors(res.data || []);
      setLoading(false);
    }).catch(err => {
      setError(err.message || 'Failed to load visitors');
      setLoading(false);
    });
  }, []);
  if (loading) {
    return <div className="p-6">
        <Card className="p-4">
          <Skeleton className="h-4 w-80" />
          <Skeleton className="h-4 w-60" />
          <Skeleton className="h-8 w-full" />
        </Card>
      </div>;
  }
  if (error) {
    return <div className="p-6">
        <Card className="p-4 text-red-500">
          <p>Error loading visitors: {error}</p>
          <Button onClick={() => {
          setError(null);
          setLoading(true);
          contactService.fetchVisitors().then(res => {
            setVisitors(res.data || []);
            setLoading(false);
          }).catch(err => {
            setError(err.message || 'Failed to load visitors');
            setLoading(false);
          });
        }} className="mt-2">
            Retry
          </Button>
        </Card>
      </div>;
  }
  return <div className="h-screen overflow-y-auto container mx-auto px-4 py-6 max-w-[1400px]">
      
      <Card className="p-6">
        <ContactListControls />
        <ContactList contacts={visitors} loading={loading} />
      </Card>
    </div>;
};
export default Visitors;